const account_center = {
    not_enabled: 'مركز الحسابات غير ممكّن.',
    filed_not_editable: 'الحقل غير قابل للتعديل.',
};
export default Object.freeze(account_center);
